export default __webpack_public_path__ + "static/media/weather-app.a2cd9056.png";